import React, { useEffect, useState } from 'react';
import { Modal, Space, Typography, message } from 'antd';
import { formatAmount } from 'util/amount';
import AmountInput from '.';

interface Props {
  open: boolean;
  title: string;
  current?: number | null;
  description?: string;
  onSave: (amount: number | null) => Promise<unknown>;
  onClose: () => void;
}

// El error del backend (409 si la ruta ya se ofertó y el monto quedó bloqueado)
// se muestra tal cual y el modal queda abierto.
const EditAmountModal: React.FC<Props> = ({
  open,
  title,
  current,
  description,
  onSave,
  onClose,
}: Props) => {
  const [value, setValue] = useState<number | null>(current ?? null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setValue(current ?? null);
  }, [open, current]);

  const save = async () => {
    setSaving(true);
    try {
      await onSave(value);
      message.success('Se actualizó el monto de la colecta.');
      onClose();
    } catch (error) {
      message.error(
        (error as Error)?.message ?? 'No se pudo actualizar el monto',
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      title={title}
      okText="Guardar"
      cancelText="Cancelar"
      confirmLoading={saving}
      okButtonProps={{ disabled: value === (current ?? null) }}
      onOk={save}
      onCancel={onClose}
      destroyOnClose
    >
      <Space direction="vertical" size={8} style={{ width: '100%' }}>
        {description && (
          <Typography.Text type="secondary">{description}</Typography.Text>
        )}
        <Typography.Text>Monto actual: {formatAmount(current)}</Typography.Text>
        <AmountInput value={value} onChange={setValue} autoFocus />
      </Space>
    </Modal>
  );
};

export default EditAmountModal;
